// extracted by mini-css-extract-plugin
export default {"alignSelected":"ImageAlignInput_alignSelected__XcFFl","imageAlignInput":"ImageAlignInput_imageAlignInput__w63Qe"};